module.exports = __webpack_public_path__ + "officialStatic/img/product-wgxt.ca0f966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-wgxt.png
// module id = ELey
// module chunks = 0